import type {MouseEvent, ReactNode} from 'react';

export interface BaseStockMediaFilterPill {
  isSelected?: boolean;
  onClick?: (e: MouseEvent) => void;
  children: ReactNode;
}

export enum StockMediaFilterPillType {
  LIST_ITEM = 'list_item',
  DROPDOWN_SELECTOR = 'dropdown_selector',
}

export interface StockMediaFilterListItemPill extends BaseStockMediaFilterPill {
  type: StockMediaFilterPillType.LIST_ITEM;
}

// Rendered as the selector of a Dropdown, which clones the element and injects onClick — hence a
// ClickableDiv instead of an <li>. isActive mirrors the dropdown's open state.
export interface StockMediaFilterDropdownSelectorPill extends BaseStockMediaFilterPill {
  type: StockMediaFilterPillType.DROPDOWN_SELECTOR;
  isActive?: boolean;
}

export type StockMediaFilterPillProps = StockMediaFilterListItemPill | StockMediaFilterDropdownSelectorPill;
